import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from '@/router/root'

const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sign-in',
  component: lazyRouteComponent(() => import('./pages'), 'SignIn'),
})

const forgotPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/forgot-password',
  component: lazyRouteComponent(() => import('./pages'), 'ForgotPassword'),
})

export const setPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/set-password',
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: lazyRouteComponent(() => import('./pages'), 'SetPassword'),
})

export const authRoutes = [signInRoute, forgotPasswordRoute, setPasswordRoute]
